import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Overlay } from '@thd-olt-component-react/overlay';
import { Image } from '@thd-olt-component-react/image';
import { ProductLoader } from '../../ProductLoader';
import ShareBeltEmail from '../ShareBeltEmail/ShareBeltEmail';
import * as actions from './share.action';
import { track } from '../../../analytics';

const ShareBeltTooltip = (props) => {

  const [pinterestOverlayOpen, setPinterestOverlayOpen] = useState(false);
  const [emailOverlayOpen, setEmailOverlayOpen] = useState(false);
  const [allImages] = useState([...document.images]);

  const experienceContext = useContext(ExperienceContext);

  const {
    channel,
    store
  } = experienceContext;

  const {
    collectionImageSrc,
    collectionId,
    email,
    hrefPath,
    itemId,
    pinterestTitle,
    toolTipClose
  } = props;

  const closeOverlays = () => {
    setEmailOverlayOpen(false);
    setPinterestOverlayOpen(false);
  };

  const onMouseEnter = (evt) => {
    let event = evt;
    event.currentTarget.querySelector('.pinterest-button__image-size').classList.add('pinterest-image--hover');
    event.currentTarget.querySelector('.pinterest-button__icon').style.display = 'block';
  };

  const onMouseLeave = (evt) => {
    let event = evt;
    event.currentTarget.querySelector('.pinterest-button__image-size').classList.remove('pinterest-image--hover');
    event.currentTarget.querySelector('.pinterest-button__icon').style.display = 'none';
  };

  const onPinImgClick = (event, data) => {
    let pinterestUrl = '';
    // The collectionImageSrc is been used as per the current
    // functionality implemented for collection
    if (collectionId) {
      pinterestUrl = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(hrefPath)
        + actions.generatePinCode(collectionId) + '&media=' + encodeURIComponent(collectionImageSrc) + '&description=' + encodeURIComponent(pinterestTitle); // eslint-disable-line max-len
    } else {
      const url = actions.getUrl(
        hrefPath,
        { fiscalYear: data?.product?.info?.fiscalYear },
        data?.product?.info?.productDepartment,
        data?.product?.info?.classNumber,
        itemId
      );
      pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${(encodeURIComponent(event.target.src))}&description=${encodeURIComponent(pinterestTitle)}`; // eslint-disable-line max-len
    }
    window.open(pinterestUrl, 'pinterest_share_dialog', 'width=626,height=436');
  };

  const onClickPinterest = (event, data) => {
    track({
      primaryCategory: 'interaction',
      eventName: 'pip sub-content',
      section: 'sharing',
      component: 'socialmedia',
      target: 'pinterest'
    });
    event.preventDefault();
    toolTipClose();
    if (collectionId) {
      onPinImgClick(event, data);
    } else {
      setPinterestOverlayOpen(true);
    }
  };

  const onClickFacebook = (event) => {
    event.preventDefault();
    track({
      primaryCategory: 'interaction',
      eventName: 'pip sub-content',
      section: 'sharing',
      component: 'socialmedia',
      target: 'facebook'
    });
    toolTipClose();
    const encodeURI = encodeURIComponent(hrefPath);
    const opts = 'width=626,height=436';
    const uri = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI}, 'facebook_share_dialog', ${opts}`;
    window.open(uri);
  };

  const onClickEmail = (event) => {
    event.preventDefault();
    track({
      primaryCategory: 'interaction',
      eventName: 'pip sub-content',
      section: 'sharing',
      component: 'socialmedia',
      target: 'email'
    });
    toolTipClose();
    setEmailOverlayOpen(true);
  };

  const getImagesForOverlay = (data) => {
    return (
      <div>
        {(allImages || []).filter((img) => img.width >= 145 && img.height >= 100).map((img, index) => {
          return (
            <button
              onMouseOver={onMouseEnter}
              onMouseLeave={onMouseLeave}
              onClick={(event) => onPinImgClick(event, data)}
              onFocus={() => {}}
              href="#"
              key={index}
              className="pinterest-button"
              type="button"
            >
              <span className="pinterest-button__image">
                <Image alt={img.alt} className="pinterest-button__image-size" src={img.src} />
                <div className="pinterest-button__icon" />
                <span className="pinterest-button__details">
                  {img.height === 300 ? 'Preferred Image' : img.height + 'x' + img.width}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    );
  };

  return (
    <div
      data-section="sharing"
      data-component="socialmedia"
      className="thd-sharebelt__tooltip"
      data-socialmedia="pinterest,facebook"
    >
      <ProductLoader itemId={itemId} domains={['info']}>
        { ({ data, error }) => {
          console.log(data, 'data');
          return (
            <>
              <button
                type="button"
                href="#"
                onClick={(event) => onClickPinterest(event, data)}
                className="thd-sharebelt__tooltip__button"
                data-target="pinterest"
              >
                <span className="thd-sharebelt-icons thd-sharebelt-icons--pinterest" />
                Pinterest
              </button>
              <Overlay
                onClose={() => closeOverlays()}
                open={pinterestOverlayOpen}
                medium
                closeButton
              >
                <div id="pinterest_header">
                  <span className="thd-sharebelt-icons thd-sharebelt-icons--pinterest" />
                  <h3 className="pinterest_headermsg">Pin It to Pinterest</h3>
                </div>
                <div id="pinterest_body">
                  { (getImagesForOverlay(data))}
                </div>
              </Overlay>
            </>
          );
        }}
      </ProductLoader>
      <button
        type="button"
        href="#"
        onClick={onClickFacebook}
        className="thd-sharebelt__tooltip__button"
        data-target="facebook"
      >
        <span className="thd-sharebelt-icons thd-sharebelt-icons--facebook" />
        Facebook
      </button>
      {email && (
        <>
          <button
            type="button"
            href="#"
            onClick={(event) => onClickEmail(event)}
            className="thd-sharebelt__tooltip__button"
            data-target="email"
          >
            <span className="thd-sharebelt-icons thd-sharebelt-icons--email" />
            Email A Friend
          </button>
          <Overlay
            onClose={() => closeOverlays()}
            open={emailOverlayOpen}
            medium
            closeButton
          >
            <header className="thd-sharebelt-email-overlay__header">
              <div className="grid">
                <div className="col__12-12"><h2 className="u__husky">Email This Product</h2></div>
              </div>
            </header>
            <ShareBeltEmail itemId={itemId} storeId={store?.storeId} />
          </Overlay>
        </>
      )}
    </div>
  );
};

ShareBeltTooltip.displayName = 'ShareBeltTooltip';

ShareBeltTooltip.propTypes = {
  collectionImageSrc: PropTypes.string,
  collectionId: PropTypes.string,
  email: PropTypes.bool,
  hrefPath: PropTypes.string,
  itemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  pinterestTitle: PropTypes.string,
  toolTipClose: PropTypes.func
};

ShareBeltTooltip.defaultProps = {
  collectionImageSrc: null,
  collectionId: null,
  email: false,
  hrefPath: null,
  itemId: null,
  pinterestTitle: null,
  toolTipClose: () => { }
};

export default ShareBeltTooltip;
